import { render, staticRenderFns } from "./index_h5.vue?vue&type=template&id=091a48a2&scoped=true&"
import script from "./index_h5.vue?vue&type=script&lang=js&"
export * from "./index_h5.vue?vue&type=script&lang=js&"
import style0 from "./index_h5.vue?vue&type=style&index=0&id=091a48a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091a48a2",
  null
  
)

export default component.exports